import { render, staticRenderFns } from "./otp.vue?vue&type=template&id=ebffa28a&scoped=true"
import script from "./otp.ts?vue&type=script&lang=ts&external"
export * from "./otp.ts?vue&type=script&lang=ts&external"
import style0 from "./otp.scss?vue&type=style&index=0&id=ebffa28a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebffa28a",
  null
  
)

export default component.exports